// extracted by mini-css-extract-plugin
module.exports = {"description":"style-module_description__VQK6vE3oM979umZ5caGp"};